import React from 'react';
import { KIND } from 'baseui/button';
import { HeadingLevel } from 'baseui/heading';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLOURS } from '@gtintel/platform-utils';
import { Add, List, ListContext } from '../../components/List';
import { RequestsContext, RequestsNavigationContext } from '../context';
import RequestEditor from './RequestEditor';
import { RequestListItem } from './RequestListItem';
export default () => {
  const ctx = React.useContext(RequestsContext);
  const navigation = React.useContext(RequestsNavigationContext);
  const [isOpen, setIsOpen] = React.useState(false);
  const [modalAssignmentId, setModalAssignmentId] = React.useState(null);
  if (ctx.anyOpen() !== null) {
    return <HeadingLevel>
        <RequestEditor />
      </HeadingLevel>;
  }
  return <ListContext.Provider value={ctx}>
      <List items={ctx.list().map(({
      id
    }) => ({
      id,
      name: `Request #${id}`
    }))} renderItem={item => {
      return <RequestListItem id={item.id} onItemClick={() => navigation.navigateTo(item.id)} setIsOpen={setIsOpen} setModalAssignmentId={setModalAssignmentId} />;
    }} />
      <Add verb="Create Request" />
      <Modal onClose={() => setIsOpen(false)} closeable isOpen={isOpen && modalAssignmentId} animate autoFocus size={SIZE.default} role={ROLE.dialog}>
        <ModalHeader>
          <FontAwesomeIcon icon={faWarning} color={COLOURS.red} />
          &nbsp; Warning
        </ModalHeader>
        <ModalBody>
          You are about to change the lead assignment to an{' '}
          <strong>active assignment</strong>. Doing so will{' '}
          <strong>activate the project</strong> and the client will receive a
          notification that the project has been activated. Are you sure you
          want to proceed?
        </ModalBody>
        <ModalFooter>
          <ModalButton kind={KIND.tertiary} onClick={() => setIsOpen(false)}>
            Cancel
          </ModalButton>
          <ModalButton onClick={() => {
          ctx.setLeadPartnerAssignment(modalAssignmentId, true);
          setIsOpen(false);
        }}>
            Proceed
          </ModalButton>
        </ModalFooter>
      </Modal>
    </ListContext.Provider>;
};